import { useEffect,useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const UserAutocomplete = forwardRef((props,ref) => {
    const {allOption, selectedValues=[], isFormikFormField = false, showFormError = false, filters = {}, ...rest} = props;
    let userOptions = allOption ? [{userName:'All Users',crsUserId:0}] : [];
    
    let initialProps = {
        ...rest,
        labelKey:'userName',
        primaryKey:'crsUserId',
        options:userOptions,
        isObject:true,
        isFormikFormField,
        showFormError,
        dataLoaded:false
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(()=>{
        const getUserOptions = async () => {
            let getUserParams = {};
            if(typeof filters?.crsRoleId === 'number' && filters?.crsRoleId > 0)
                getUserParams = {...getUserParams, roleId:filters.crsRoleId}
            if(typeof filters?.crsActive === 'number' && filters?.crsActive >= 0)
                getUserParams = {...getUserParams, crsActive:filters.crsActive}
            if(typeof filters?.msActive === 'number' && filters?.msActive >= 0)
                getUserParams = {...getUserParams, msActive:filters.msActive}

            const response = await fetchApi('masters/getUsers',getUserParams,userToken);
            if(response.status === 'Ok' && response.data.responseStatus === 'Ok'){
                let newOptions = [];
                if(allOption)
                    newOptions.push({userName:'All Users',crsUserId:0});
                    
                if(response.data.users.length > 0){
                    newOptions = newOptions.concat(response.data.users);
                }
                let preSelectedValues = [];
                if(selectedValues.length > 0){
                    preSelectedValues =  newOptions.filter((u) => selectedValues.indexOf(u.crsUserId) >= 0);
                }
                const newProps = {...defaultProps, options:newOptions, preSelectedValues,dataLoaded:true}
                setDefaultProps(newProps);
            }
        }
        getUserOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    return ( defaultProps.dataLoaded ? 
        !isFormikFormField ? 
        <MultiSelectDropDown
            ref={ref}
            {...defaultProps}
        /> :
        <MultiSelectDropDownForm
            ref={ref}
            {...defaultProps}
        />  : <></>
    );
});

export default UserAutocomplete;